/**
 * orga app | api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MandantNotificationMessage { 
    content?: string;
    notification_type?: string;
    user_name?: string;
    user_id?: string;
    id?: string;
    timestamp_utc?: string;
    tags?: Array<string>;
    feature?: string;
    empfaenger_benutzer_ids?: Array<string>;
    mandant_id?: string;
    clr_type?: string;
    send_to_all?: boolean;
}

